function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "75",
  height: "44",
  viewBox: "0 0 75 44"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "2",
  d: "M16.57 43A14.96 14.96 0 011.65 28a14.96 14.96 0 0118.93-14.45A19.87 19.87 0 0138.12 3C48 3 56.2 10.25 57.74 19.75c5.75.7 10.21 5.62 10.21 11.58 0 6.45-5.2 11.67-11.6 11.67H16.57zm18.57-22.77v12.21"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  d: "M28.5 25.56l6.63-6.66 6.63 6.66"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeWidth: "2",
  d: "M50.73 15.35c.19-.21.27-.49.26-.77a10.28 10.28 0 010-1.16c.01-.28-.07-.56-.26-.77l-1.86-2.11a1 1 0 01-.12-1.16l2.16-3.75a1 1 0 011.07-.49l2.74.57c.27.05.56-.01.79-.16.32-.22.65-.41 1-.58.25-.13.44-.34.53-.61l.89-2.67a1 1 0 01.95-.69h4.3a1 1 0 01.95.69L65 4.36c.1.27.29.48.54.6.34.18.67.37 1 .59.23.15.51.21.79.16l2.74-.57a1 1 0 011.07.49l2.15 3.75a1 1 0 01-.11 1.16l-1.87 2.11c-.18.21-.27.49-.25.77a10.28 10.28 0 010 1.16c-.02.28.07.56.25.77l1.87 2.11a1 1 0 01.11 1.16l-2.15 3.75a1 1 0 01-1.07.49l-2.74-.57c-.28-.05-.56.01-.8.16-.32.22-.65.41-1 .58a1.1 1.1 0 00-.53.61l-.88 2.67a1 1 0 01-.95.69h-4.3a1 1 0 01-.95-.69l-.89-2.67a1.06 1.06 0 00-.53-.6c-.35-.18-.68-.37-1-.59a1.06 1.06 0 00-.8-.16l-2.73.57a1 1 0 01-1.07-.49l-2.16-3.75a1 1 0 01.12-1.16l1.86-2.11z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "61.32",
  cy: "14",
  r: "1.54",
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeWidth: "2"
})));